"use strict";

exports.__esModule = true;
exports.UserEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _FormGroupField = require("../../Form/FormGroupField");
var _Heading = require("../../Core/Heading");
var _PasswordEditor = require("../../Form/PasswordEditor");
var _Core = require("../../Core");
var _RoleListContext = require("../../Role/RoleListContext");
var _PlantListContext = require("../../Plant/PlantListContext");
var _EmailEditor = require("../../Form/EmailEditor");
var _FieldError = require("../../Form/FieldError");
var _System = require("../../../System");
var _inputValidation = require("../../../Utils/inputValidation");
var _reactIntl = require("react-intl");
var _ProfileContext = require("../../Profile/ProfileContext/ProfileContext");
var _ProfilePermissionsContext = require("../../Profile/ProfilePermissionsContext/ProfilePermissionsContext");
var _dec, _dec2, _dec3, _dec4, _class, _UserEditor;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var UserEditorForm = _styledComponents["default"].form.withConfig({
  displayName: "UserEditor__UserEditorForm",
  componentId: "sc-17io0tc-0"
})(["display:flex;flex:1;overflow:auto;flex-direction:column;height:100%;h3{font-size:22px;margin:0 0 10px 0;}"]);
var EditorBody = _styledComponents["default"].div.withConfig({
  displayName: "UserEditor__EditorBody",
  componentId: "sc-17io0tc-1"
})(["padding:1rem;display:flex;flex-direction:column;"]);
var EditorBodyWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UserEditor__EditorBodyWrapper",
  componentId: "sc-17io0tc-2"
})(["display:flex;flex-direction:row;"]);
var EditorBodyHalf = _styledComponents["default"].div.withConfig({
  displayName: "UserEditor__EditorBodyHalf",
  componentId: "sc-17io0tc-3"
})(["display:flex;flex-direction:column;padding:0 1rem;"]);
var permissionToEditUsers = "users:update";

/**
 * Users editor form
 */
var UserEditor = exports.UserEditor = (_dec = _RoleListContext.RoleListContext.withContext, _dec2 = _PlantListContext.PlantListContext.withContext, _dec3 = _ProfileContext.ProfileContext.withContext, _dec4 = _ProfilePermissionsContext.ProfilePermissionsContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (0, _Core.withTranslator)(_class = (_UserEditor = /*#__PURE__*/function (_Component) {
  function UserEditor() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    // While editing, a value the user has not touched is left as stored. Rules
    // added after a record was created must not make it unsaveable: a field-level
    // error marks the whole form invalid, which disables Save for every other
    // change -- and a read-only field could never be corrected anyway. On create
    // there are no stored values, so everything is validated.
    _this.isStoredAndUntouched = function (meta) {
      return Boolean(_this.props.id) && (0, _inputValidation.isUnmodified)(meta);
    };
    _this.validateFirstName = function (value, allValues, meta) {
      var translator = _this.props.translator;
      var translate = translator.translate;
      if (_this.isStoredAndUntouched(meta)) {
        return undefined;
      }
      if (!value || !value.trim()) {
        return translate("UserEditor.validateFirstName.required", "First Name is required.");
      }
      return (0, _inputValidation.translateValidationError)((0, _inputValidation.validatePersonName)(value), translate);
    };
    // Last name is optional, so there is no presence check -- only the shared
    // character and length rules.
    _this.validateLastName = function (value, allValues, meta) {
      var translator = _this.props.translator;
      var translate = translator.translate;
      if (_this.isStoredAndUntouched(meta)) {
        return undefined;
      }
      return (0, _inputValidation.translateValidationError)((0, _inputValidation.validatePersonName)(value), translate);
    };
    _this.validateName = function (username, allValues, meta) {
      var _this$props = _this.props,
        translator = _this$props.translator,
        userList = _this$props.userList,
        value = _this$props.value;
      var translate = translator.translate;
      if (_this.isStoredAndUntouched(meta)) {
        return undefined;
      }
      if (!username || !username.trim()) {
        return translate("UserEditor.validateName.required", "Name is required.");
      }
      var formatError = (0, _inputValidation.translateValidationError)((0, _inputValidation.validateUsername)(username), translate);
      if (formatError) {
        return formatError;
      }
      var isUsernameTaken = userList.some(function (user) {
        return user.username.toLowerCase() === username.toLowerCase();
      });
      if (value.username === "" && isUsernameTaken) {
        return translate("UserEditor.validateName.usernameTaken", "Username is already taken.");
      }
    };
    _this.isPlantTouched = function (touched) {
      if (touched) {
        var plantKeys = Object.keys(touched).filter(function (key) {
          return key.match(/plant/);
        });
        return plantKeys.reduce(function (acc, plantKey) {
          return acc || touched[plantKey];
        }, false);
      }
      return false;
    };
    _this.isRoleTouched = function (touched) {
      if (touched) {
        var roleKeys = Object.keys(touched).filter(function (key) {
          return key.match(/role/);
        });
        return roleKeys.some(function (roleKey) {
          return touched[roleKey];
        });
      }
      return false;
    };
    _this.validateForm = function (values) {
      var errors = {};
      var translator = _this.props.translator;
      var translate = translator.translate;
      var isPlantSelected = values.plants && values.plants.length && values.plants.some(function (plant) {
        return !!plant;
      });
      if (!isPlantSelected) {
        errors.plants = [translate("UserEditor.validateForm.plantRequired", "Select at least one plant")];
      }
      var isRoleSelected = values.roles && values.roles.length && values.roles.some(function (role) {
        return !!role;
      });
      if (!isRoleSelected) {
        errors.roles = [translate("UserEditor.validateForm.roleRequired", "Select at least one role")];
      }
      return errors;
    };
    _this.getPreSelectedPlants = function (selectedPlants, plantList) {
      if (!selectedPlants || !selectedPlants.length) return [];
      return plantList.map(function (plant) {
        return selectedPlants.find(function (selectedPlant) {
          return plant.id === selectedPlant;
        }) ? true : "";
      });
    };
    _this.getPreSelectedRoles = function (selectedRoles, roleList) {
      if (!selectedRoles || !selectedRoles.length) return [];
      return roleList.map(function (role) {
        return selectedRoles.find(function (selectedRole) {
          return role.id === selectedRole;
        }) ? true : "";
      });
    };
    _this.getSelectedPlants = function (selectedPlants) {
      var plantList = _this.props.plantList;
      return plantList.filter(function (plant, index) {
        return selectedPlants[index];
      }).map(function (plant) {
        return plant.id;
      });
    };
    _this.getSelectedRoles = function (selectedRoles) {
      var roles = _this.props.roles;
      return roles.filter(function (role, index) {
        return selectedRoles[index];
      }).map(function (role) {
        return role.id;
      });
    };
    _this.handleSubmit = function (values) {
      var id = _this.props.id;
      var formattedValues = {
        isEnabled: values.isEnabled,
        username: values.username.trim() ? values.username.trim() : "",
        profile: {
          email: values.email ? values.email.trim() : "",
          name: {
            first: values.firstName ? values.firstName.trim() : "",
            last: values.lastName ? values.lastName.trim() : ""
          }
        },
        plants: _this.getSelectedPlants(values.plants),
        roles: _this.getSelectedRoles(values.roles)
      };
      var passwords = values.password ? {
        password: values.password.trim(),
        rePassword: values.rePassword && values.rePassword.trim()
      } : {};
      var onSubmit = _this.props.onSubmit;
      id ? onSubmit(Object.assign({}, formattedValues, passwords), id) : onSubmit(Object.assign({}, formattedValues, passwords));
    };
    _this.shouldEnableEditingUser = function () {
      var profilePermissions = _this.props.profilePermissions;
      var isEditable = _this.props.value.isEditable;
      return (profilePermissions == null ? void 0 : profilePermissions.userPermissions.includes(permissionToEditUsers)) && isEditable;
    };
    return _this;
  }
  _inheritsLoose(UserEditor, _Component);
  var _proto = UserEditor.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      value = _this$props2.value,
      roles = _this$props2.roles,
      plantList = _this$props2.plantList,
      id = _this$props2.id,
      translate = _this$props2.translator.translate;
    var isEditable = value.isEditable;
    var initialValues = Object.assign({}, value, {
      plants: this.getPreSelectedPlants(value.plants, plantList),
      roles: this.getPreSelectedRoles(value.roles, roles)
    });
    var makeTranslationId = function makeTranslationId(roleName) {
      return roleName.split(" ").join("");
    };
    var canEditInputFields = this.shouldEnableEditingUser();
    return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      initialValues: Object.assign({}, initialValues),
      validate: this.validateForm,
      onSubmit: this.handleSubmit
    }, function (_ref) {
      var handleSubmit = _ref.handleSubmit,
        pristine = _ref.pristine,
        invalid = _ref.invalid,
        touched = _ref.touched,
        submitting = _ref.submitting;
      return /*#__PURE__*/_react["default"].createElement(UserEditorForm, {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterCompat.Prompt, {
        when: !pristine && !submitting,
        message: translate("UserEditor.form.prompt.message", "Are you sure you want to leave this page without saving your changes?")
      }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
        style: {
          marginLeft: "auto"
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
        type: "submit",
        icon: _icons.IconNames.FLOPPY_DISK,
        intent: _core.Intent.PRIMARY,
        text: translate("UserEditor.saveButton.text", "Save"),
        disabled: pristine || invalid || !canEditInputFields
      }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
        minimal: true,
        end: true,
        icon: _icons.IconNames.CROSS,
        to: (0, _System.getScreenLocation)("UserList"),
        text: translate("UserEditor.cancelButton.text", "Cancel")
      }))), /*#__PURE__*/_react["default"].createElement(EditorBody, null, !isEditable && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: "#ff4d4d",
          padding: "1rem"
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "UserEditor.isEditable.message.id",
        defaultMessage: translate("UserEditor.isEditable.message", "This user cannot be edited because it is handled by a third-party authenticator.")
      })), /*#__PURE__*/_react["default"].createElement(EditorBodyWrapper, null, /*#__PURE__*/_react["default"].createElement(EditorBodyHalf, null, /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
        level: "3"
      }, translate("UserEditor.detailsHeading", "Details")), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "firstName",
        requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
        label: translate("UserEditor.firstName.label", "First Name"),
        validate: _this2.validateFirstName
      }, function (_ref2) {
        var input = _ref2.input;
        return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
          disabled: !canEditInputFields,
          "data-testid": "firstName"
        }));
      }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "lastName",
        label: translate("UserEditor.lastName.label", "Last Name"),
        validate: _this2.validateLastName
      }, function (_ref3) {
        var input = _ref3.input;
        return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
          disabled: !canEditInputFields,
          "data-testid": "lastName"
        }));
      }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "username",
        label: translate("UserEditor.username.label", "username"),
        requiredLabel: /*#__PURE__*/_react["default"].createElement(_Core.RequiredLabel, null),
        validate: _this2.validateName
      }, function (_ref4) {
        var input = _ref4.input;
        return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({}, input, {
          disabled: !!id || !canEditInputFields,
          "data-testid": "username"
        }));
      }), /*#__PURE__*/_react["default"].createElement(_EmailEditor.EmailEditor, {
        disabled: !canEditInputFields,
        isNew: !id
      }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "isEnabled",
        type: "checkbox",
        label: translate("UserEditor.enable.label", "User Status")
      }, function (_ref5) {
        var input = _ref5.input;
        return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
          label: translate("UserEditor.enable.enabled.label", "Enabled")
        }, input, {
          disabled: !canEditInputFields,
          "data-testid": "isEnabled"
        }));
      }), /*#__PURE__*/_react["default"].createElement(_PasswordEditor.PasswordEditor, {
        id: id,
        allowEmptyPassword: true,
        disabled: !canEditInputFields
      })), /*#__PURE__*/_react["default"].createElement(EditorBodyHalf, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: /*#__PURE__*/_react["default"].createElement("h3", null, translate("UserEditor.plants.label", "Plants")),
        helperText: translate("UserEditor.plants.helperText", "Select at least one plant for the user.")
      }, plantList.map(function (plant, index) {
        return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
          key: plant.id,
          name: "plants[" + index + "]",
          type: "checkbox"
        }, function (_ref6) {
          var input = _ref6.input;
          return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
            label: plant.name
          }, input, {
            disabled: !canEditInputFields,
            "data-testid": "plant-" + plant.name
          }));
        });
      }), /*#__PURE__*/_react["default"].createElement(_FieldError.FieldError, {
        name: "plants",
        touched: _this2.isPlantTouched(touched)
      })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: /*#__PURE__*/_react["default"].createElement("h3", null, translate("UserEditor.roles.label", "Roles")),
        helperText: translate("UserEditor.roles.helperText", "Select at least one role for the user.")
      }, roles.map(function (role, index) {
        return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
          key: role.id,
          name: "roles[" + index + "]",
          type: "checkbox"
        }, function (_ref7) {
          var input = _ref7.input;
          return /*#__PURE__*/_react["default"].createElement(_core.Checkbox, _extends({
            label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
              id: "UserEditor.roles." + makeTranslationId(role.name),
              defaultMessage: role.name
            })
          }, input, {
            disabled: !canEditInputFields,
            "data-testid": "role-" + role.name
          }));
        });
      }), /*#__PURE__*/_react["default"].createElement(_FieldError.FieldError, {
        name: "roles",
        touched: _this2.isRoleTouched(touched)
      }))))));
    });
  };
  return UserEditor;
}(_react.Component), _UserEditor.defaultProps = {
  translator: undefined,
  roles: undefined,
  plantList: undefined,
  profile: undefined,
  profilePermissions: undefined
}, _UserEditor)) || _class) || _class) || _class) || _class) || _class);